import styled from 'styled-components';
import {
  CTAAction,
  CTADescription,
  CTASection,
  CTATitle,
} from '@/scenes/common/CTA/styles';
import { breakpoints } from '@/styles/breakpoints';

const StoriesCtaSection = styled.div`
  ${CTASection} {
    padding: 52px 0 76px;

    ${breakpoints.MD} {
      padding: 69px 0 55px;
    }

    ${breakpoints.MDL} {
      padding: 167px 0 55px;
    }

    ${breakpoints.LG} {
      padding: 163px 0 79px;
    }
  }

  ${CTATitle} {
    ${breakpoints.MDL} {
      top: 158px;
    }
  }

  ${CTAAction} {
    margin-left: -32px;

    ${breakpoints.MD} {
      margin-left: 128px;
    }

    ${breakpoints.MDL} {
      margin-left: 176px;
    }

    ${breakpoints.LG} {
      margin-left: 0;
      position: relative;
      left: 215px;
    }
  }

  ${CTADescription} {
    margin-top: -10px;

    ${breakpoints.MD} {
      margin-top: -4px;
    }

    ${breakpoints.LG} {
      margin-top: 3px;
    }
  }
`;

export { StoriesCtaSection };
